import React from "react";
import { NumericFormat } from "react-number-format";
import { TextFieldProps } from "@mui/material/TextField";
import WcTextField from "../WcTextfield/WcTextField";
import InputAdornment from "@mui/material/InputAdornment";

export type WcCurrencyProps = TextFieldProps & {
  displayType?: any;
  onValue?: any;
  inputDefaultValue?: string | number;
};

export const WcCurrency = ({ onValue, displayType, variant = "filled", inputDefaultValue, sx, ...others }: WcCurrencyProps) => (
  // @ts-ignore
  (<NumericFormat
    sx={[...(Array.isArray(sx) ? sx : [sx])]}
    customInput={WcTextField}
    decimalSeparator=","
    thousandSeparator="."
    inputMode="numeric"
    decimalScale={2}
    variant={variant}
    displayType={displayType ? displayType : "input"}
    fixedDecimalScale
    onFocus={(event) => {
      event.target.select();
    }}
    InputProps={{
      startAdornment: <InputAdornment position="start">€</InputAdornment>,
    }}
    // @ts-ignore
    defaultValue={inputDefaultValue || others.defaultValue}
    {...others}
    onValueChange={(values) => {
      const { formattedValue, value, floatValue } = values;
      if (onValue) onValue(floatValue);
    }}
  />)
);

export default WcCurrency;
